// File Embed block schema - Embed images or PDFs directly on your page
export const fileEmbedSchema = {
  type: 'file-embed',
  label: 'File Embed',
  description: 'Embed images or PDFs directly on your page',
  icon: 'FileImage',
  defaultContent: {
    heading: '',
    files: [], // Array of { id, url, fileName, fileType, fileSize }
    style: {},
  },
};
